import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { ProvedorDeSessao } from './ganchos/usarSessao'
import './estilo.css'
import './estilo-react.css'

const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('elemento #raiz não existe no index.html')

createRoot(raiz).render(
  <StrictMode>
    <BrowserRouter>
      {/* Por FORA do roteador não daria: a tela de entrada precisa do
          `navigate` para levar ao painel depois de entrar. Por dentro,
          e por fora do <App/>, porque quem decide se o painel existe é
          o porteiro lá dentro. */}
      <ProvedorDeSessao>
        <App />
      </ProvedorDeSessao>
    </BrowserRouter>
  </StrictMode>,
)
